export function isTokenExpired() {
  const token = localStorage.getItem("x-access-token");
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiration = payload.exp * 1000; // exp em milissegundos

    return Date.now() > expiration;
  } catch (err) {
    console.error("Erro ao validar token:", err);
    return true;
  }
}
